import { Sport } from '@/types';
import React, { useEffect } from 'react';
import { Game } from '../types/games_api_types';
import GameScorecard from './GameScorecard';
import GameProperties from './GameProperties';
import TimeZoneExplanation from '../shared/TimeZoneExplanation';

export default function GamePage({
  gameUid,
  sport,
}: {
  gameUid: string;
  sport: Sport;
}) {
  const [game, setGame] = React.useState<Game | null>(null);

  useEffect(() => {
    const getData = async () => {
      const response = await fetch(`/api/v1/games/${sport}/${gameUid}.json`);
      const data = await response.json();
      setGame(data);
    };
    getData();
    let intervalID = window.setInterval(getData, 10000);

    return () => {
      if (intervalID) {
        clearInterval(intervalID);
      }
    };
  }, [gameUid, sport]);

  return (
    <div className="tray">
      <div className="inner-tray">
        {game === null ? (
          <div>Loading...</div>
        ) : (
          <>
            <GameScorecard game={game} />
            <GameProperties game={game} />
            <TimeZoneExplanation />
          </>
        )}
      </div>
    </div>
  );
}
